import React from 'react';

const Capabilities = () => {
  return (
    <div className="capabilities-section w-screen bg-white py-20 sm:pb-[100px] border-t">
      <div className="content max-w-[1120px] mx-auto max-sm:pt-[5vh] pt-[9vh]">
        <div className="text-indigo-600 font-semibold sm:text-lg">
          Continuously monitor and optimize your compensation strategy
        </div>
        <div className="flex flex-col gap-4 mt-8 -ml-1">
          <h3 className="text-4xl sm:text-6xl font-bold tracking-tighter">Global Compensation Analytics</h3>
        </div>

        <div className="flex flex-wrap gap-4 mt-8">
          <div
            className="bg3 flex-1 min-w-[300px] bg-white p-6 rounded-2xl text-center fade-up scroll-mt-28"
            style={{ flexBasis: '48%' }}
          >
            <span id="global-pay-gap-reporting" className="scroll-mt-28"></span>
            <span id="equal-pay-regression-modeling" className="scroll-mt-28"></span>
            <div className="relative inline-flex items-center overflow-hidden rounded-full mx-auto mb-4">
              <div className="absolute inset-0 pill-wrapper"></div>
              <div
                className="pill-content relative z-10 text-[13px] font-medium text-gray-600 bg-white 
                  flex flex-row items-center justify-center gap-1 text-nowrap px-3 py-1"
              >
                Compliance Expertise
              </div>
            </div>

            <h4 className="font-bold text-xl mb-4">Global Pay Gap Reporting</h4>
            <p className="text-gray-600 text-sm mb-4">
              Effortlessly meet gender pay gap reporting requirements with our
              <span data-british=" centralised"> centralized</span> platform. We leverage machine learning and AI to
              ensure data cleaning meets data integrity.
            </p>
            <div className="flex flex-row justify-center gap-2">
              <div
                className="squared-pill relative z-10 text-[13px] font-medium text-gray-600 bg-white 
                    flex flex-row items-center justify-center gap-1 text-nowrap px-3 py-1"
              >
                Jurisdiction-Level Pay Gap Reporting
              </div>
              <div
                className="squared-pill relative z-10 text-[13px] font-medium text-gray-600 bg-white 
                    flex flex-row items-center justify-center gap-1 text-nowrap px-3 py-1"
              >
                Equal Pay Regression Modeling
              </div>
            </div>
            <img className="pt-4" src="/images/country_dashboard.png" alt="Country Dashboard" />
          </div>
          <div
            className="bg3 flex-1 min-w-[300px] bg-white p-6 rounded-2xl text-center fade-up scroll-mt-28"
            style={{ flexBasis: '48%' }}
          >
            <span id="eu-pay-transparency-directive" className="scroll-mt-28"></span>
            <div className="relative inline-flex items-center overflow-hidden rounded-full mx-auto mb-4">
              <div className="absolute inset-0 pill-wrapper"></div>
              <div
                className="pill-content relative z-10 text-[13px] font-medium text-gray-600 bg-white 
                  flex flex-row items-center justify-center gap-1 text-nowrap px-3 py-1"
              >
                Compensation Confidence
              </div>
            </div>
            <h4 className="font-bold text-xl mb-4">EU Pay Transparency Directive</h4>
            <p className="text-gray-600 text-sm mb-4">
              Our EU Pay Transparency solution drives accurate, compliant reporting and insightful analysis to
              proactively manage pay transparency and pay equity.
            </p>
            <div className="flex flex-row justify-center gap-2">
              <div
                className="squared-pill relative z-10 text-[13px] font-medium text-gray-600 bg-white 
                    flex flex-row items-center justify-center gap-1 text-nowrap px-3 py-1"
              >
                EU CSRD ESRS Social Reporting
              </div>
              <div
                className="squared-pill relative z-10 text-[13px] font-medium text-gray-600 bg-white 
                    flex flex-row items-center justify-center gap-1 text-nowrap px-3 py-1"
              >
                UN SDG 5 Alignment
              </div>
            </div>
            <img className="pt-4" src="/images/eu_pay_transparency_directive.png" alt="EU Pay Transparency Directive" />
          </div>
          <div className="bg3 w-full bg-white p-6 rounded-2xl text-center fade-up scroll-mt-28">
            <span id="compensation-analytics-consulting" className="scroll-mt-28"></span>
            <div className="relative inline-flex items-center overflow-hidden rounded-full mx-auto mb-4">
              <div className="absolute inset-0 pill-wrapper"></div>
              <div
                className="pill-content relative z-10 text-[13px] font-medium text-gray-600 bg-white 
                  flex flex-row items-center justify-center gap-1 text-nowrap px-3 py-1"
              >
                Driven by Data Science
              </div>
            </div>
            <h4 className="font-bold text-xl mb-4">Compensation Analytics Consulting</h4>
            <p className="text-gray-600 text-sm mb-4 px-1 sm:px-20 text-left" style={{ textIndent: '3em' }}>
              Our team of engineers and data scientists combines deep expertise in machine learning, AI, people
              analytics, and total rewards strategy. We build tailored, data-driven solutions that{' '}
              <span data-british=" optimise"> optimize</span> compensation strategy, pay equity, and global pay-related
              compliance. Our track record includes company-wide equal pay regression modeling for Fortune 100 firms,
              identifying compensation-driven attrition risks among top talent, and{' '}
              <span data-british=" analysing "> analyzing </span>
              competitor pay and total rewards strategies. We’re tech-agnostic and highly adaptive, partnering closely
              with the world’s top rewards and compensation teams to tackle their toughest challenges. Our approach sets
              our customers apart in what matters most to employees: their pay.
            </p>
            <img className="pt-4" src="/images/consulting.png" alt="Compensation Consulting" />
          </div>
        </div>

        <div className="flex justify-center mt-8"></div>
      </div>
    </div>
  );
};

export default Capabilities;
